import { useSelector } from 'react-redux';
import { userIdIreneSelector } from '../../selectors';

export function useCurrentUserAsEmployee(employees) {
  const userToken = useSelector(userIdIreneSelector);
  return employees.find((employee) => employee.id === userToken);
}

export const ERROR_STEP = 'error';
export const LANDING_STEP = 'landing';
export const NAME_STEP = 'name';
export const SUCCESS_STEP = 'success';
export const ACCESS_UNAVAILABLE_STEP = 'accessUnavailable';
